export const __DEV__ = process.env.NODE_ENV === "development";
export const API_URL = process.env.REACT_APP_API_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const APP_KEY = process.env.REACT_APP_OPENINSTALL_APP_KEY;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
